module.exports = __webpack_public_path__ + "static/media/YF65_2.c630bff0.jpg";